import { LabelConfigInterface } from '../interfaces/label-config-interface';

export class LabelConfigModel implements LabelConfigInterface {
  label = '';
  value?: any | undefined;
  class?: string = '';
  type?: 'SIMPLE' | 'STYLISH' | 'ARRAY' = 'SIMPLE';
  title?: boolean = false;
  href?: boolean = false;
  bootstrapCol?: string = '';
  currency?: boolean = false;
  currencyCodeOverride?: string;
  translate?: boolean = false;
  property?: string = '';
  isDiscontinued?: boolean = false;
  displayFieldArrayName?: string = '';
  percentage?: boolean = false;

  constructor(init?: Partial<LabelConfigModel>) {
    Object.assign(this, init);
  }
}
